import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { organizationInterests } from '../mockData/organization-interests-data';

const OrganizationInterestsApi = [
  rest.get(`${API_ROOT}libraries/organization-interests`, (req, res, ctx) => res(ctx.json(organizationInterests))),
  rest.get(`${API_ROOT}libraries/organization-interests/${organizationInterests[0].id}`, (req, res, ctx) => res(ctx.json(organizationInterests[0]))),
  rest.put(`${API_ROOT}libraries/organization-interests/${organizationInterests[0].id}`, (req, res, ctx) => res(ctx.json(organizationInterests[0]))),
  rest.post(`${API_ROOT}libraries/organization-interests`, (req, res, ctx) => res(ctx.json(organizationInterests[1]))),
  rest.delete(`${API_ROOT}libraries/organization-interests/${organizationInterests[0].id}`, (req, res, ctx) =>
    res(ctx.json(organizationInterests[0])),
  ),
];

export default OrganizationInterestsApi;
